module.exports = __webpack_public_path__ + "static/media/new_qblogo.ad894854.svg";